import React, { useState } from "react";
import { Button, Loader, Message } from "rsuite";
import { getData, postData } from "../../utils/reusables";
import { apiUrls } from "../../utils/apiUrls";
import { AxiosResponse } from "axios";
import { typeApiResponse, typeFormDto } from "../../utils/typeDefs";

function NewsAggregator() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [resultData, setResultData] = useState<typeApiResponse>({
    statusCode: 0,
    succeeded: false,
    message: "",
    errors: [],
  });

  const handleButtonClick = () => {
    setLoading(true);
    postData(apiUrls.newsaggregator.aggregatingnews, resultData)
      .then((result: AxiosResponse<typeApiResponse>) => {
        setResultData(result.data);
        setMessage(result.data.message);
      })
      .catch(() => {
        setMessage("News Aggregation processed failed.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Button
        className={"primary-color"}
        onClick={handleButtonClick}
        disabled={loading}
      >
        {loading ? "Loading..." : "Fetch News"}
      </Button>
      {loading && (
        <Loader
          backdrop
          content="News aggregation process running..."
          vertical
        />
      )}
      {message && (
        <div className="message-container">
          <Message
            className="mt-2"
            showIcon
            type={resultData.succeeded ? "success" : "error"}
          >
            {message}
          </Message>
        </div>
      )}
    </div>
  );
}

export default NewsAggregator;
